import { render, staticRenderFns } from "./peoSc.vue?vue&type=template&id=40beee2a&scoped=true&"
import script from "./peoSc.vue?vue&type=script&lang=js&"
export * from "./peoSc.vue?vue&type=script&lang=js&"
import style0 from "./peoSc.vue?vue&type=style&index=0&id=40beee2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40beee2a",
  null
  
)

export default component.exports